<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'
import 'vue2-datepicker/index.css'
import integer from 'vuelidate/lib/validators/integer'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { formatDate , parseDate } from '@router/date-utils'

import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  decimal,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

export default {
  name: 'UpdateRequest',
  props: {
    requestId: { type: [String, Number], required: true },
  },
  components: {
    Multiselect,
    DateRangePicker,
  },
  data() {
    return {
      loandingData: true,
      carriers: [],
      directions: [],
      containers: [],
      equipments: [],
      requestData: {
        carriers: [],
        containers: [],
        validation: [],
        direction: {},
        equipment: {},
      },
    }
  },
  validations: {
    requestData: {
      carriers: { required },
      direction: { required },
      validation: { required },
      equipment: { required },
      containers: { required },
    },
  },
  watch: {},
  computed: {},
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    fetchData() {
      axiosGetPost(
        'post',
        'requests/manageRequest',
        {
          id: this.requestId,
        },
        'Load data to update request FCL'
      ).then((response) => {
        let data = response.data
        if (response.success) {
          this.matchSelects(data['selects'])
          this.matchData(data['data'])
          this.loandingData = false
        }
      })
    },
    matchSelects(data) {
      this.carriers = data.carriers
      this.directions = data.directions
      this.equipments = data.equipments
      this.containers = data.containers
    },
    matchData(data) {
      this.requestData.carriers = data.carriers
      this.requestData.direction = data.direction
      this.requestData.validation = {
        startDate: parseDate(data.validation[0]),
        endDate: parseDate(data.validation[1]),
      }
      this.requestData.equipment = data.equipment
      this.requestData.containers = data.containers
      this.requestData.code = data.code
      this.requestData.name = data.name
      this.requestData.company_user = data.company_user
    },
    clear_containers() {
      this.requestData.containers = []
      this.containers = []
      axiosGetPost('post', 'requests/getContainers', {
        id: this.requestData.equipment.id,
      }).then((response) => {
        let data = response.data
        if (response.success) {
          this.containers = data
        }
      })
    },
    validate_fields() {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastr.e('Field is required')
        response = false
      }
      return response
    },
    update_request() {
      let date = formatDate(this.requestData.validation)
      if (this.validate_fields()) {
        axiosGetPost(
          'put',
          'requests/manageRequest',
          {
            id: this.requestId,
            name: this.requestData.name,
            carriers: this.requestData.carriers,
            direction: this.requestData.direction,
            validation: date,
            equipment: this.requestData.equipment,
            containers: this.requestData.containers,
          },
          'Update request FCL'
        ).then((response) => {
          let data = response.data
          if (response.success) {
            this.$toastr.s('Update Requests and Contract FCL')
            this.$emit('close_modal')
          }
        })
      }
    },
    question_update() {
      this.$swal({
        title:
          'Are you sure you want to update this request ' +
          this.requestId +
          '? This action is irreversible.',
        showCancelButton: true,
        confirmButtonColor: 'green',
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.update_request()
        } else {
          this.$swal('Cancelled')
          this.$emit('close_modal')
        }
      })
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loandingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group">
        <div class="row">
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default">Carrier: </label>
            <multiselect
              v-model="requestData.carriers"
              select-label=""
              :options="carriers"
              :multiple="true"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
            <div v-if="$v.requestData.carriers.$error" style="color: red">
              * This value is required.
            </div>
          </div>
          <div class="col-md-5">
            <label class="mb-1 mt-0">Validation</label>
            <date-range-picker
              opens="center"
              :locale-data="{
                format: 'yyyy-mm-dd',
                separator: ' / ',
                direction: 'ltr',
              }"
              class="col-md-12"
              v-model="requestData.validation"
              timezone="local"
            >
            </date-range-picker>
            <div v-if="$v.requestData.validation.$error" style="color: red">
              * This value is required.
            </div>
          </div>
          <div class="col-md-3">
            <label class="mb-1 mt-0" for="default">Direction: </label>
            <multiselect
              v-model="requestData.direction"
              select-label=""
              :options="directions"
              placeholder="Select one"
              label="name"
              track-by="name"
            ></multiselect>
            <div v-if="$v.requestData.direction.$error" style="color: red">
              * This value is required.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default">Equipment: </label>
            <multiselect
              v-model="requestData.equipment"
              select-label=""
              :options="equipments"
              placeholder="Select one"
              label="name"
              track-by="name"
              @input="clear_containers"
            ></multiselect>
            <div v-if="$v.requestData.equipment.$error" style="color: red">
              * This value is required.
            </div>
          </div>
          <div class="col-md-5">
            <label class="mb-1 mt-0" for="default">Containers: </label>
            <multiselect
              v-model="requestData.containers"
              :options="containers"
              :multiple="true"
              placeholder="Select one"
              selectLabel=""
              label="code"
              track-by="code"
            ></multiselect>
            <div v-if="$v.requestData.carriers.$error" style="color: red">
              * This value is required.
            </div>
          </div>
          <div class="col-md-3">
            <label class="mb-1 mt-0" for="default">Code: </label>
            <b-form-input
              id="name"
              v-model="requestData.code"
              readonly
              value
              placeholder="code"
            >
            </b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-md-8">
            <label class="mb-1 mt-0" for="default">Name Contract: </label>
            <b-form-input
              id="name"
              v-model="requestData.name"
              value
              placeholder="code"
            >
            </b-form-input>
          </div>
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default">Company User: </label>
            <b-form-input
              id="name"
              v-model="requestData.company_user"
              readonly
              value
              placeholder="code"
            >
            </b-form-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-3">
            <!-- Asegúrate de añadir un margen en la parte superior para separar el botón del último elemento de tu formulario -->
            <b-button variant="primary" class="col-4" @click="question_update"
              >Update</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.my-custom-class .flatpickr-input {
  max-width: 100% !important; /* o cualquier otro valor que prefieras */
  width: 100% !important;
}
</style>